/* eslint-disable no-fallthrough */
import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab';
import { List, ListItemButton, Stack, Typography } from '@mui/material';
import { Scrollbar } from 'app/components';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
const DUT_KEYS = ['dut1', 'dut2', 'dut3', 'dut4', 'dut5', 'dut6'];
function sumDutValues(data) {
    return DUT_KEYS.map((key) => data[key])
        .filter((value) => typeof value === 'number' && value >= 0)
        .reduce((sum, value) => sum + value, 0);
}
function buildFlightItems(conditionItems) {
    return conditionItems
        .filter((condition) => condition.type === 'message')
        .reduce((accumulator, currentValue) => {
        var _a, _b, _c;
        const guard_status = (currentValue.data.guard_status >>> 0).toString(2).padStart(9, '0');
        const guard_status_sum = sumDutValues(currentValue.data);
        switch (currentValue.data.geofence_type) {
            case 3:
                if (accumulator[accumulator.length - 1] === undefined || accumulator[accumulator.length - 1].datetime_end) {
                    return [
                        ...accumulator,
                        {
                            datetime: currentValue.datetime,
                            geofence: currentValue.data.geofence_name,
                            datetime_end: null,
                            datetime_loaded: null,
                            total_mileage: currentValue.data.total_mileage,
                            total_mileage_end: null,
                            drain: [
                                {
                                    datetime: null,
                                    datetime_end: null,
                                    geofence: null,
                                    parking_time: [],
                                },
                            ],
                        },
                    ];
                }
                return accumulator;
            case 1:
                if (accumulator[accumulator.length - 1] !== undefined && accumulator[accumulator.length - 1].datetime_end === null) {
                    if (guard_status[2] !== '0') {
                        if (accumulator[accumulator.length - 1].drain.length !== 0) {
                            accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime = accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime
                                ? accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime
                                : currentValue.datetime;
                            accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].geofence_name =
                                accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].geofence_name
                                    ? accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].geofence_name
                                    : currentValue.data.geofence_name;
                            return accumulator;
                        }
                        if (accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime_end) {
                            accumulator[accumulator.length - 1].drain.push({
                                datetime: currentValue.datetime,
                                geofence: currentValue.data.geofence_name,
                                parking_time: [],
                            });
                            return accumulator;
                        }
                    }
                    // Специальное намерение исключить разрыв конструкции switch.
                }
            default:
                if (accumulator[accumulator.length - 1] !== undefined && accumulator[accumulator.length - 1].datetime_end === null) {
                    switch (guard_status[2]) {
                        case '0':
                            if (guard_status_sum < 300) {
                                accumulator[accumulator.length - 1].datetime_end = currentValue.datetime;
                                accumulator[accumulator.length - 1].total_mileage_end = currentValue.data.total_mileage;
                            }
                            if (accumulator[accumulator.length - 1].datetime_loaded === null) {
                                accumulator[accumulator.length - 1].datetime_loaded = currentValue.datetime;
                            }
                            if (accumulator[accumulator.length - 1].drain.length !== 0) {
                                if (accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime) {
                                    accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime_end =
                                        currentValue.datetime;
                                    return accumulator;
                                }
                                if (currentValue.data.parking_time !== 0) {
                                    if (accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time
                                        .length !== 0) {
                                        accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time[accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time.length -
                                            1] = (_a = currentValue.data.parking_time) !== null && _a !== void 0 ? _a : 0;
                                        return accumulator;
                                    }
                                    accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time.push((_b = currentValue.data.parking_time) !== null && _b !== void 0 ? _b : 0);
                                    return accumulator;
                                }
                                if (accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time.length !==
                                    0) {
                                    if (accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time[accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time.length -
                                        1] !== 0) {
                                        accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time.push((_c = currentValue.data.parking_time) !== null && _c !== void 0 ? _c : 0);
                                    }
                                }
                            }
                    }
                }
                return accumulator;
        }
    }, [])
        .reverse();
}
const MapTransportFlightList = ({ renderEmpty }) => {
    const conditionItems = useSelector((state) => { var _a, _b; return (_b = (_a = state.map.transportSelectedItem) === null || _a === void 0 ? void 0 : _a.conditions) !== null && _b !== void 0 ? _b : []; });
    const items = useMemo(() => buildFlightItems(conditionItems), [conditionItems]);
    const formatDuration = (diff) => {
        const humanize = [];
        moment.relativeTimeThreshold('h', 23);
        moment.relativeTimeThreshold('m', 59);
        if (~~(diff / 60) > 0) {
            if (~~(diff / 60) <= 1) {
                humanize.push(`1 ${moment.duration(1, 'hours').humanize()}`);
            }
            else {
                humanize.push(moment.duration(~~(diff / 60), 'hours').humanize());
            }
        }
        if (diff % 60 > 0) {
            if (diff % 60 <= 1) {
                humanize.push(`1 ${moment.duration(1, 'minutes').humanize()}`);
            }
            else {
                humanize.push(moment.duration(Math.max(diff % 60, 1), 'minutes').humanize());
            }
        }
        return humanize.join(' ');
    };
    if (items.length === 0) {
        return renderEmpty();
    }
    return (React.createElement(Stack, { direction: 'column', sx: (theme) => ({
            width: '100%',
            height: '100%',
            bgcolor: 'background.default',
            borderTop: '1px solid',
            borderColor: theme.palette.divider,
            '.MuiList-root': {
                padding: theme.spacing(2),
            },
            '.simplebar-container': {
                maxHeight: 'none',
            },
        }) },
        React.createElement(Scrollbar, null,
            React.createElement(List, { disablePadding: true, sx: (theme) => ({
                    padding: theme.spacing(2),
                }) }, items.map((value, index) => {
                var _a;
                return (React.createElement(TimelineItem, { key: index, sx: (theme) => ({
                        display: 'flex',
                        width: '100%',
                        minHeight: 'auto',
                        WebkitBoxPack: 'start',
                        position: 'relative',
                        '&:before': {
                            display: 'none',
                        },
                        '&:first-of-type': {
                            '.MuiTimelineConnector-root': {
                                marginTop: '10px',
                            },
                            '.MuiTimelineDot-root': {
                                bgcolor: theme.palette.primary.main,
                            },
                        },
                        '&:last-of-type': {
                            '.MuiTimelineConnector-root': {
                                height: '13px',
                                marginBottom: theme.spacing(0),
                            },
                        },
                        '.MuiTimelineItemButton-root': {
                            padding: theme.spacing(0),
                            cursor: 'default',
                        },
                        '.MuiTimelineDot-root': {
                            position: 'absolute',
                            top: '8.5px',
                            left: '4px',
                            bgcolor: 'background.paper',
                            border: '5px solid',
                            borderColor: theme.palette.primary.main,
                            margin: theme.spacing(0),
                            boxShadow: 'none',
                            '&.MuiTimelineDot-filledPrimary': {
                                bgcolor: theme.palette.primary.main,
                            },
                        },
                        '.MuiTimelineConnector-root': {
                            height: '100%',
                            border: '1px dashed',
                            bgcolor: 'transparent',
                            marginBottom: '2px',
                            marginRight: '4px',
                            flexGrow: 'unset',
                            borderColor: theme.palette.primary.main,
                        },
                        '.MuiTimelineSeparator-root': {
                            width: '30px',
                            height: '100%',
                            flex: 'none',
                            position: 'relative',
                        },
                        '.MuiTimelineContent-root': {
                            padding: '0',
                        },
                    }) },
                    React.createElement(ListItemButton, { disableTouchRipple: true, className: 'MuiTimelineItemButton-root' },
                        React.createElement(TimelineSeparator, null,
                            React.createElement(TimelineDot, null),
                            React.createElement(TimelineConnector, null)),
                        React.createElement(TimelineContent, null,
                            React.createElement(Stack, { direction: 'column' },
                                React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '6px',
                                        position: 'relative',
                                        bgcolor: 'background.paper',
                                        border: '1px solid',
                                        borderColor: theme.palette.divider,
                                        borderRadius: theme.shape.borderRadius,
                                        padding: theme.spacing(2),
                                        marginBottom: '8px',
                                        '&:before': {
                                            top: '16px',
                                            width: '10px',
                                            left: '-5px',
                                            height: '10px',
                                            zIndex: '0',
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            transform: 'translateY(-50%) rotate(45deg)',
                                            bgcolor: 'background.paper',
                                            borderLeft: '1px solid',
                                            borderBottom: '1px solid',
                                            borderColor: theme.palette.divider,
                                        },
                                        '.MuiTypography-root': {
                                            fontSize: '12px',
                                            lineHeight: '16px',
                                        },
                                    }) },
                                    React.createElement(Stack, { direction: 'row' },
                                        value.datetime_loaded && (React.createElement(Typography, { variant: 'h6' },
                                            "\u041D\u0430\u0447\u0430\u043B\u043E \u0440\u0435\u0439\u0441\u0430 - ",
                                            value.geofence,
                                            " ",
                                            moment(value.datetime).format('HH:mm'),
                                            " -",
                                            ' ',
                                            moment(value.datetime_loaded).format('HH:mm'),
                                            " (",
                                            formatDuration(moment(value.datetime_loaded).diff(value.datetime, 'minutes')),
                                            ")")),
                                        !value.datetime_loaded && (React.createElement(Typography, { variant: 'h6' },
                                            "\u041D\u0430\u0447\u0430\u043B\u043E \u0440\u0435\u0439\u0441\u0430 - ",
                                            value.geofence,
                                            " ",
                                            moment(value.datetime).format('HH:mm'),
                                            " - \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435"))),
                                    value.drain
                                        .filter((drain) => drain.datetime)
                                        .map((drain, key) => (React.createElement(Stack, { key: key, direction: 'column', sx: (theme) => ({
                                            '.MuiTypography-root:first-of-type': {
                                                marginLeft: '20px',
                                            },
                                            '.MuiTypography-root:last-of-type': {
                                                marginLeft: '20px',
                                                color: theme.palette.primary.main,
                                            },
                                        }) },
                                        React.createElement(Typography, { component: 'span' },
                                            "\u0412\u0440\u0435\u043C\u044F \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043E\u043A \u0432 \u043F\u0443\u0442\u0438 ",
                                            formatDuration(drain.parking_time.reduce((a, b) => a + b, 0) / 60)),
                                        drain.datetime_end && (React.createElement(Typography, { component: 'span' },
                                            "\u0421\u043B\u0438\u0432 #",
                                            key + 1,
                                            " - ",
                                            drain.geofence,
                                            " ",
                                            moment(drain.datetime).format('HH:mm'),
                                            " -",
                                            ' ',
                                            moment(drain.datetime_end).format('HH:mm'),
                                            " (",
                                            formatDuration(moment(drain.datetime_end).diff(drain.datetime, 'minutes')),
                                            ")")),
                                        !drain.datetime_end && (React.createElement(Typography, { component: 'span' },
                                            "\u0421\u043B\u0438\u0432 #",
                                            key + 1,
                                            " - ",
                                            drain.geofence,
                                            " ",
                                            moment(drain.datetime).format('HH:mm'),
                                            " - \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435"))))),
                                    React.createElement(Stack, { direction: 'row' },
                                        value.datetime_end && value.total_mileage_end != null && (React.createElement(Typography, { component: 'span' },
                                            "\u0420\u0435\u0439\u0441 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D \u0432 ",
                                            moment(value.datetime_end).format('HH:mm'),
                                            " (",
                                            formatDuration(moment(value.datetime_end).diff(value.datetime, 'minutes')),
                                            "). \u041F\u0440\u043E\u0431\u0435\u0433 \u0441\u043E\u0441\u0442\u0430\u0432\u0438\u043B ",
                                            Math.round((value.total_mileage_end - value.total_mileage) / 1000).toLocaleString('ru'),
                                            ' ',
                                            config.conditions.total_mileage.unit)),
                                        !value.datetime_end && React.createElement(Typography, { component: 'span' }, "\u0420\u0435\u0439\u0441 \u043D\u0435 \u043E\u043A\u043E\u043D\u0447\u0435\u043D"))),
                                ((_a = items[index + 1]) === null || _a === void 0 ? void 0 : _a.datetime_end) && (React.createElement(Stack, { direction: 'row', justifyContent: 'center', sx: (theme) => ({
                                        padding: theme.spacing(0, 2),
                                        marginBottom: '8px',
                                        '.MuiTypography-root:last-of-type': {
                                            color: 'text.secondary',
                                        },
                                    }) },
                                    React.createElement(Typography, { component: 'span' },
                                        "\u0412\u0440\u0435\u043C\u044F \u043F\u0440\u043E\u0441\u0442\u043E\u044F \u043C\u0435\u0436\u0434\u0443 \u0440\u0435\u0439\u0441\u0430\u043C\u0438 ",
                                        moment(items[index + 1].datetime_end).format('HH:mm'),
                                        " -",
                                        ' ',
                                        moment(value.datetime).format('HH:mm'),
                                        " (",
                                        formatDuration(moment(value.datetime).diff(items[index + 1].datetime_end, 'minutes')),
                                        ")"))))))));
            })))));
};
export default MapTransportFlightList;
